import { createIntl, createIntlCache, RawIntlProvider } from "react-intl";
import localesConfig from "./locales-config";

const cache = createIntlCache();

const DEFAULT_LOCALE = "de-DE";

function findLocaleCnf(locale: string): any {
  return localesConfig.find(({ locales }) => {
    return locales.some((l) => l.toLowerCase() === locale.toLowerCase());
  });
}

const intlStore = (locale: string, timezone: string | undefined) => {
  const defaultLocaleCnf = findLocaleCnf(DEFAULT_LOCALE);
  const localeCnf = findLocaleCnf(locale);

  const messages = {
    ...(defaultLocaleCnf?.messages || {}),
    ...(localeCnf?.messages || {}),
  };

  return createIntl(
    {
      locale: localeCnf?.id ?? defaultLocaleCnf?.id,
      defaultLocale: defaultLocaleCnf?.id,
      timeZone: timezone,
      messages,
    },
    cache
  );
};

type IntlProps = {
  locale: string;
  timezone?: string;
  children?: JSX.Element;
};

const IntlProvider = ({ locale, timezone, children }: IntlProps) => {
  const intl = intlStore(locale, timezone);

  return <RawIntlProvider value={intl}>{children}</RawIntlProvider>;
};

function resolveLocaleId(locale: string | undefined) {
  if (locale == null) return undefined;
  return findLocaleCnf(locale)?.id;
}

export { resolveLocaleId, DEFAULT_LOCALE };
export default IntlProvider;
